exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".format-picker---T0fQv {\n  text-align: left; }\n  .format-picker---T0fQv .content---M-1UU {\n    margin: 0; }\n  .format-picker---T0fQv .report-format---3SEdZ {\n    margin-top: 20px; }\n  .format-picker---T0fQv .report-format---3SEdZ .header---2cp64 {\n      font-weight: bold; }\n  .format-picker---T0fQv .report-format---3SEdZ .footer---2_NGM {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: end;\n          -ms-flex-pack: end;\n              justify-content: flex-end;\n      margin-top: 10px; }\n  .format-picker---T0fQv .report-format---3SEdZ .radio-group---1LfjD {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      height: 40px;\n      border: 1px #a2c4e3 solid; }\n  .format-picker---T0fQv .report-format---3SEdZ .radio-group---1LfjD .radio---3O5rE {\n        margin: 0 10px; }\n", ""]);

// exports
exports.locals = {
	"format-picker": "format-picker---T0fQv",
	"content": "content---M-1UU",
	"report-format": "report-format---3SEdZ",
	"header": "header---2cp64",
	"footer": "footer---2_NGM",
	"radio-group": "radio-group---1LfjD",
	"radio": "radio---3O5rE"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/sub-heading/format-picker/format-picker.scss
// module id = 1DBy
// module chunks = 1